import { SharesTransferExcelModalContextType } from '../types/SharesTransferExcelModalContextType';

export const sharesTransferExcelModalInitValue: SharesTransferExcelModalContextType =
  {
    data: {
      step: 'upload',
      excelPreview: null,
      excelFile: undefined,
      isLoading: false,
      isParsingExcel: false,
      isExecuting: false,
      executeProgress: { completed: 0, total: 0 },
      holdingClassId: null,
      holdingClassName: null,
    },
    actions: {
      handleCloseModal: () => {},
      handleChangeExcelFile: async () => {},
      handleDownloadExcelTemplate: () => {},
      handleBackToUpload: () => {},
      handleSelectOperationType: () => {},
      handleExecuteFromExcel: async () => {},
    },
  };
